<template lang='pug'>
//- 快速開始選單
div(:class='$style[`cc-popbox-startup`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-wrap`]')
      section(:class='$style[`cc-content-wrap-drcell`]')
        header(:class='$style[`cc-content-wrap-header`]')
          figure(:class='$style[`cc-content-drcell-logo`]')
          span.font-bold AI 智慧照護
        ul(:class='$style[`cc-banner-wrap-ul`]')
          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='我的儀錶板'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(``)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconChart(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 儀錶板

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='記錄副作用'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/post`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconEpro(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 建立紀錄

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='回報血糖與血壓'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/blood`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconBlood(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 血糖血壓

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='求助 AI'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`?v=0`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconDrCell(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 求助 AI

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='線上諮詢專家'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/consult`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconDialog(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 諮詢專家

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='報告解說'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/translator`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconTranslate(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 報告解說

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='飲食管家'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/diet`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconDiet(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 飲食管家

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='健檢預測'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/summary`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconGuild(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 健檢預測

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='我的紀錄'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`sideeffect/record`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconFilter(:size='42' :color='`#60a5c5`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 我的紀錄

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='我的病歷'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`ecard`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconData(:size='42' :color='`#cfd051`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 我的病歷

      section(:class='$style[`cc-content-wrap-course`]')
        header(:class='$style[`cc-content-wrap-header`]')
          span.font-bold 衛教與社群
        ul(:class='$style[`cc-banner-wrap-ul`]')
          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='線上課程'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`course`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconIdeas(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 線上課程

          //- li(:class='$style[`cc-banner-wrap-list`]')
          //-   button(
          //-     tabindex='0'
          //-     aria-label='QA問答'
          //-     :class='$style[`cc-banner-wrap-list-btn`]'
          //-     @click='handleClickFeatureBtn(`aidoctor`)')
          //-     div(:class='$style[`cc-banner-wrap-top`]')
          //-       IconSearch(:size='42' :color='`#6aa5df`')
          //-     div(:class='$style[`cc-banner-wrap-bottom`]')
          //-       span.font-medium(:class='$style[`cc-banner-wrap-title`]') QA問答

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='講座活動'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`events`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconFollower(:size='42' :color='`#44c1a9`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 講座活動

          //- li(:class='$style[`cc-banner-wrap-list`]')
          //-   button(
          //-     tabindex='0'
          //-     aria-label='公益資源'
          //-     :class='$style[`cc-banner-wrap-list-btn`]'
          //-     @click='handleClickFeatureBtn(`help`)')
          //-     div(:class='$style[`cc-banner-wrap-top`]')
          //-       IconBless(:size='42')
          //-     div(:class='$style[`cc-banner-wrap-bottom`]')
          //-       span.font-medium(:class='$style[`cc-banner-wrap-title`]') 公益資源

          li(:class='$style[`cc-banner-wrap-list`]')
            a(
              tabindex='0'
              aria-label='加入LINE社群'
              :class='$style[`cc-banner-wrap-list-btn`]'
              href='https://line.me/ti/g2/chXi7R_fSWK7XhdmkafV-Qd_rX2mi9clshPpcw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default'
              target='_blank'
              rel='noopener noreferrer')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconLine(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 加入社群

      section(:class='$style[`cc-content-wrap-course`]')
        header(:class='$style[`cc-content-wrap-header`]')
          span.font-bold 個人中心、其他服務
        ul(:class='$style[`cc-banner-wrap-ul`]')

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='訂閱方案'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`shop/subscribe`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconCcoin(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 訂閱方案

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='訂閱照護組合'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`shop/business`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconCcoin(:size='42')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 商務方案

          //- li(:class='$style[`cc-banner-wrap-list`]')
          //-   button(
          //-     tabindex='0'
          //-     aria-label='保健商店'
          //-     :class='$style[`cc-banner-wrap-list-btn`]'
          //-     @click='handleClickFeatureBtn(`shop/bundle`)')
          //-     div(:class='$style[`cc-banner-wrap-top`]')
          //-       IconPill(:size='42')
          //-     div(:class='$style[`cc-banner-wrap-bottom`]')
          //-       span.font-medium(:class='$style[`cc-banner-wrap-title`]') 照護組合

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='交易紀錄'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`orders`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconMoney(:size='42' :color='`#efb300`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 交易紀錄

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='帳戶設定'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`setting`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconSetting(:size='42' :color='`#89cd83`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 帳戶設定

          //- li(:class='$style[`cc-banner-wrap-list`]')
          //-   a(
          //-     tabindex='0'
          //-     aria-label='加入LINE社群'
          //-     :class='$style[`cc-banner-wrap-list-btn`]'
          //-     href='https://line.me/ti/g2/chXi7R_fSWK7XhdmkafV-Qd_rX2mi9clshPpcw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default'
          //-     target='_blank'
          //-     rel='noopener noreferrer')
          //-     div(:class='$style[`cc-banner-wrap-top`]')
          //-       IconLine(:size='42')
          //-     div(:class='$style[`cc-banner-wrap-bottom`]')
          //-       span.font-medium(:class='$style[`cc-banner-wrap-title`]') 加入社群

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='問題回報'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`feedback`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconQuestion(:size='42' :color='`#849bd7`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 問題回報

          li(:class='$style[`cc-banner-wrap-list`]')
            button(
              tabindex='0'
              aria-label='關於Cancell'
              :class='$style[`cc-banner-wrap-list-btn`]'
              @click='handleClickFeatureBtn(`about`)')
              div(:class='$style[`cc-banner-wrap-top`]')
                IconAgree(:size='42' :color='`#009fa5`')
              div(:class='$style[`cc-banner-wrap-bottom`]')
                span.font-medium(:class='$style[`cc-banner-wrap-title`]') 關於公司

      //- section(:class='$style[`cc-content-wrap-course`]')
      //-   header(:class='$style[`cc-content-wrap-header`]')
      //-     span.font-bold 社群、其他服務
      //-   ul(:class='$style[`cc-banner-wrap-ul`]')
      //-     li(:class='$style[`cc-banner-wrap-list`]')
      //-       a(
      //-         tabindex='0'
      //-         aria-label='LINE社群'
      //-         :class='$style[`cc-banner-wrap-list-btn`]'
      //-         href='https://line.me/ti/g2/chXi7R_fSWK7XhdmkafV-Qd_rX2mi9clshPpcw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default'
      //-         target='_blank'
      //-         rel='noopener noreferrer')
      //-         div(:class='$style[`cc-banner-wrap-top`]')
      //-           IconLine(:size='42')
      //-         div(:class='$style[`cc-banner-wrap-bottom`]')
      //-           span.font-medium(:class='$style[`cc-banner-wrap-title`]') LINE社群

      //-     li(:class='$style[`cc-banner-wrap-list`]')
      //-       button(
      //-         tabindex='0'
      //-         aria-label='問題回報'
      //-         :class='$style[`cc-banner-wrap-list-btn`]'
      //-         @click='handleClickFeatureBtn(`feedback`)')
      //-         div(:class='$style[`cc-banner-wrap-top`]')
      //-           IconQuestion(:size='42' :color='`#849bd7`')
      //-         div(:class='$style[`cc-banner-wrap-bottom`]')
      //-           span.font-medium(:class='$style[`cc-banner-wrap-title`]') 問題回報

      //-     li(:class='$style[`cc-banner-wrap-list`]')
      //-       button(
      //-         tabindex='0'
      //-         aria-label='關於Cancell'
      //-         :class='$style[`cc-banner-wrap-list-btn`]'
      //-         @click='handleClickFeatureBtn(`about`)')
      //-         div(:class='$style[`cc-banner-wrap-top`]')
      //-           IconAgree(:size='42' :color='`#009fa5`')
      //-         div(:class='$style[`cc-banner-wrap-bottom`]')
      //-           span.font-medium(:class='$style[`cc-banner-wrap-title`]') 關於公司

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconResumeCard from '../../icon/ResumeCard';
import IconDialog from '../../icon/Dialog';
import IconTranslate from '../../icon/Translate';
import IconDiet from '../../icon/Diet';
import IconData from '../../icon/Data';
import IconMoney from '../../icon/Money';
import IconDrCell from '../../icon/DrCell';
import IconFilter from '../../icon/Filter';
import IconEpro from '../../icon/Epro';
import IconSearch from '../../icon/Search';
import IconGuild from '../../icon/Guild';
import IconCourse from '../../icon/Course';
import IconFollower from '../../icon/Follower';
import IconBless from '../../icon/Bless';
import IconPill from '../../icon/Pill';
import IconCcoin from '../../icon/Ccoin';
import IconLine from '../../icon/Line';
import IconSetting from '../../icon/Setting';
import IconIdeas from '../../icon/Ideas';
import IconWrite from '../../icon/Write';
import IconAgree from '../../icon/Agree';
import IconChart from '../../icon/Chart';
import IconQuestion from '../../icon/Question';
import IconBlood from '../../icon/Blood';

export default {
  components: {
    IconResumeCard,
    IconDialog,
    IconTranslate,
    IconData,
    IconDiet,
    IconMoney,
    IconDrCell,
    IconFilter,
    IconEpro,
    IconSearch,
    IconGuild,
    IconCourse,
    IconFollower,
    IconBless,
    IconPill,
    IconCcoin,
    IconLine,
    IconSetting,
    IconIdeas,
    IconWrite,
    IconAgree,
    IconChart,
    IconQuestion,
    IconBlood,
  },

  // data() {
  //   return {
  //   }
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopStartupStatus: 'global/POPSTARTUP_STATUS',
    }),

    handleClosePopBox() {
      this.changePopStartupStatus({
        active: false,
      });
    },

    handleClickFeatureBtn(path) {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }
      this.$router.push({ path: `/${path}` }).catch(() => true);
      this.handleClosePopBox();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // authJwtToken: 'user/exportUserJwtToken',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popStartup.scss';
</style>
